import { GridColDef,GridRenderCellParams } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import "i18n/config";
import i18next from "i18next";

/*
"id_assessment": 23,
"id_function": "DE",
"function_name": "DETECT (DE)",
"id_category": "DE.AE",
"category_name": "Anomalies and Events (DE.AE)",
"id_subcategory": "DE.AE-1",
"subcategory_fncs": "DE.AE-1: Sono definite, rese note e gestite delle pratiche di riferimento (c.d. baseline) inerenti l'utilizzo della rete ed i flussi informativi attesi per utenti e sistemi",
"id": 0,
"score": 40,
"maturity": 60*/

export async function getColumns(locale:string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id_function', 
      headerName: i18next.t('FN'), 
      width: 50
    },
    {
      field: 'category_name',
      headerName: i18next.t('Category'),
      width: 190 
    },
    {
      field: 'id',
      headerName: i18next.t('Subcategory'),
      width: 90 
    },
    {
      field: 'subcategory_fncs',
      headerName: i18next.t('FNCS'),
      flex: 1,

    },
    {
      field: 'score',
      headerName: i18next.t('Coverage'),
      width: 120,
      renderCell: (params: GridRenderCellParams<any>) =>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: 70, mr: 1 }}>
          <LinearProgress variant="determinate" value={params.value} color="primary"/>
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.primary">{`${Math.round(
            params.value
          )}%`}</Typography>
        </Box>
      </Box>
    },   
    {
      field: 'maturity',
      headerName: i18next.t('Maturity'),
      width: 120,
      renderCell: (params: GridRenderCellParams<any>) =>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: 70, mr: 1 }}>
          <LinearProgress variant="determinate" value={params.value} color="info" />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.primary">{`${Math.round(
            params.value
          )}%`}</Typography>
        </Box>
      </Box>
    }
  ] as GridColDef[]
};